import React from "react";
import View from "../ReactNative/View";
import Text from "../ReactNative/Text";
import AppTheme from "../../utils/Theme";
import PremiumButton from "../../designSystem/PremiumButton";
import Colors from "../../Theme/Colors";
import Fonts from "../../Theme/Fonts";
import Button from "../../designSystem/Button";
import User from "../../data/user/User";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";

interface PremiumAdBlockProps {
    onPress?: () => void;
}

const PremiumAdBlock = (props: PremiumAdBlockProps) => {

    const { onPress } = props;
    const appTheme: AppTheme = new AppTheme();
    const user: User = User.getInstance();

    const {
        fullScreenWidth,
        fullScreenHeight,
        availableScreenSize,
        contentSize,
        sideMenuSize,
        horizontalSpacing
    } = useSpecificSize();

    if (user.isPremium() === true) {
        return null;
    }

    const horizontalPadding: number = appTheme.pixelPerfect(10);
    const verticalPadding: number = appTheme.pixelPerfect(10);
    const cellWidth: number = contentSize - 2 * horizontalPadding;

    return <View style={{ width: contentSize, paddingVertical: verticalPadding, paddingHorizontal: horizontalPadding, alignItems: "center", marginVertical: appTheme.pixelPerfect(10) }}>
        <View style={{ borderRadius: appTheme.pixelPerfect(14), backgroundColor: "#354F84", width: cellWidth, paddingVertical: verticalPadding, paddingHorizontal: horizontalPadding }}>
            <View style={{ flexDirection: "row" }}>
                <PremiumButton size={appTheme.pixelPerfect(30)} iconSize={appTheme.pixelPerfect(18)} />
                <Text style={[{ flex: 1, fontFamily: Fonts.primary.bold, textAlign: "center", color: "#FFD77A", fontSize: appTheme.pixelPerfectForFont(9), textTransform: "uppercase" }]}>
                    {"Envie d'avoir toutes\nles clés en main ?"}
                </Text>
            </View>
            <Text style={{ paddingVertical: verticalPadding, flex: 1, fontFamily: Fonts.primary.regular, textAlign: "center", color: "#ffffff", fontSize: appTheme.pixelPerfectForFont(9) }}>
                {"Ne vous arrêtez pas en si bon chemin ! Plus de 18 heures de conseils d’experts et l'ensemble de nos activités audio vous attendent pour désamorcer les crises, accompagner votre enfant et vivre plus sereinement votre quotidien de parent."}
            </Text>
            <Button onPress={onPress} title={"Je démarre ma semaine gratuite"} textStyle={{ color: appTheme.darkBlue }} style={{ marginVertical: verticalPadding, backgroundColor: "#FFD77A", height: appTheme.pixelPerfect(40) }} />
        </View>
    </View>
}

export default PremiumAdBlock;